<template>
    <div class="col-md-10 side-content-holder">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'HATS Dashboard'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/View.vue